import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "social-media" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "social-media__link-text"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "social-media__link-text"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "social-media__link-text"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "social-media__link-text"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "social-media__link-text"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 0,
  class: "social-media__link-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (social, index) => {
      return (_openBlock(), _createElementBlock("span", {
        class: _normalizeClass([`social-media__container--${social.type}`]),
        key: index
      }, [
        (social.type === 'pinterest')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "social-media__link social-media__link--pinterest",
              href: `${social.url}?url=${_ctx.productStore.productDetails.product.productUrl}`,
              target: "_blank",
              rel: "nofollow noopener",
              "aria-label": "pinterest link"
            }, [
              (social.name && _ctx.showSocialName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(social.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true),
        _cache[0] || (_cache[0] = _createTextVNode()),
        (social.type === 'facebook')
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "social-media__link social-media__link--facebook",
              href: `${social.url}?u=${_ctx.productStore.productDetails.product.productUrl}`,
              target: "_blank",
              rel: "nofollow noopener",
              "aria-label": "facebook link"
            }, [
              (social.name && _ctx.showSocialName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(social.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (social.type === 'twitter')
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "social-media__link social-media__link--twitter",
              href: `${social.url}?url=${_ctx.productStore.productDetails.product.productUrl}`,
              target: "_blank",
              rel: "nofollow noopener",
              "aria-label": "twitter link"
            }, [
              (social.name && _ctx.showSocialName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(social.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_6))
          : _createCommentVNode("v-if", true),
        _cache[2] || (_cache[2] = _createTextVNode()),
        (social.type === 'mail')
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "social-media__link social-media__link--mail",
              href: `${social.url}%20${_ctx.productStore.productDetails.product.productUrl}`,
              rel: "nofollow noopener",
              target: "_blank",
              "aria-label": "mail link"
            }, [
              (social.name && _ctx.showSocialName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(social.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_8))
          : _createCommentVNode("v-if", true),
        _cache[3] || (_cache[3] = _createTextVNode()),
        (social.type === 'whatsapp')
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              class: "social-media__link social-media__link--whatsapp",
              href: `${social.url}%20${_ctx.productStore.productDetails.product.productUrl}`,
              rel: "nofollow noopener",
              target: "_blank",
              "aria-label": "whatsapp link"
            }, [
              (social.name && _ctx.showSocialName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(social.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_10))
          : _createCommentVNode("v-if", true),
        _cache[4] || (_cache[4] = _createTextVNode()),
        (social.type === 'instagram')
          ? (_openBlock(), _createElementBlock("a", {
              key: 5,
              class: "social-media__link social-media__link--instagram",
              href: social.url,
              target: "_blank",
              rel: "nofollow noopener",
              "aria-label": "instagram link"
            }, [
              (social.name && _ctx.showSocialName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(social.name), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_12))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}